import {AuthLoginScreen} from 'pages/layouts'
import {RouteMap} from '../RouteMap'
import {RouteParamAuth} from './RouteParamAuth'

export const ROUTE_MAP_AUTH: RouteMap<RouteParamAuth> = {
  auth_login: {
    component: AuthLoginScreen,
    path: '/',
    permission: 'guest',
  },
}
